import { render, staticRenderFns } from "./OrderData.vue?vue&type=template&id=031a9417&scoped=true&"
import script from "./OrderData.vue?vue&type=script&lang=js&"
export * from "./OrderData.vue?vue&type=script&lang=js&"
import style0 from "./OrderData.vue?vue&type=style&index=0&id=031a9417&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031a9417",
  null
  
)

export default component.exports